<ng-content></ng-content>
<div [class.hotspot-active]="isHotspotDetailActive" *ngIf="isHotspotActive && hotspotDetail" class="hotspot-wrapper" [ngStyle]="hotspotDetail.position" [ngClass]="hotspotClasses">
  <div class="hotspot-container">
    <div class="oval-container" (click)="toggleHotspotDetail()">
      <div class="inner-oval"></div>
    </div>
    <div *ngIf="isHotspotDetailActive" class="hotspot-message">
      <div class="hotspotDetail" [innerHTML]="hotspotDetail.text"></div>
      <div *ngIf="hotspotDetail && hotspotDetail.buttons && hotspotDetail.buttons.length" class="hotspot-button-container">
        <ui-button [ngClass]="button.customClass" (clicked)="btnClicked(button)" *ngFor="let button of hotspotDetail.buttons">{{
          button.label
        }}</ui-button>
      </div>
    </div>
  </div>
</div>
